import { apiGet } from '@/services/api';
import type { SessionUser } from '@/app/types/SessionUser';

/** The session bootstrap's request — SessionProvider calls this, never the URL. */
export const sessionApi = {
  /**
   * Who is signed in. Answers 401 when nobody is; SessionProvider catches it and leaves the
   * decision to RequireSession (see the comment on its unauthorized handler).
   */
  me: () => apiGet<SessionUser>('/api/v1/me'),
};
